module.exports = __webpack_public_path__ + "static/media/2-4-1_Spot_UV_Glossy_01.1017cd60.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/printing-information/Printing-Techniques/2-4-1_Spot_UV_Glossy_01.jpg
// module id = 565
// module chunks = 0